const ThumbIcon = ({ size = 11, fill = '#CE181E' }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 11 11"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8 10.5H3V4L6.5 0.5L7.125 1.125C7.18333 1.18333 7.23125 1.2625 7.26875 1.3625C7.30625 1.4625 7.325 1.55833 7.325 1.65V1.825L6.775 4H9.5C9.76667 4 10 4.1 10.2 4.3C10.4 4.5 10.5 4.73333 10.5 5V6C10.5 6.05833 10.4938 6.12083 10.4812 6.1875C10.4688 6.25417 10.45 6.31667 10.425 6.375L8.925 9.9C8.85 10.0667 8.725 10.2083 8.55 10.325C8.375 10.4417 8.19167 10.5 8 10.5ZM2 4V10.5H0V4H2Z"
        fill={fill}
      />
    </svg>
  );
};

export default ThumbIcon;
